// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD     = require('./_object-gopd')
  , $export  = require('./_export')
  , anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return gOPD.f(anObject(target), propertyKey);
  }
});


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/core-js/modules/es6.reflect.get-own-property-descriptor.js
// module id = ../../../../core-js/modules/es6.reflect.get-own-property-descriptor.js
// module chunks = 0